<template>
	<div>
		<div class="bio-pane active">
			<div class="search-bar">
				<el-form ref="form" label-width="120px">
					<label>日期 <el-date-picker size="small" style="width:220px" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" v-model="filter.date" @change="handleFilter(3,1, $event)"></el-date-picker></label>
					<div style="display: inline-block;">
						数据源
						<el-select size="small" filterable clearable placeholder="请选择" v-model="filter.dataType" @change="handleFilter(3,2, $event)">
							<el-option v-for="item in sourceList" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</div>
					<div class="flr">
						<el-button type="primary" size="mini" round @click="onShowForm('add')">添加血压</el-button>
						<el-link class="mode noline" :class="{active: viewMode == 1}" @click="handleMode(1)"><i class="icon-table"></i></el-link>
						<el-link class="mode noline" :class="{active: viewMode == 2}" @click="handleMode(2)"><i class="icon-chart2"></i></el-link>
					</div>
				</el-form>
			</div>
			
			<div class="pane-mode table-wrap" :class="{active: viewMode == 1}">
				<el-table ref="multipleTable" header-cell-class-name="tab-cell" cell-class-name="tab-cell" border :data="list.data" v-loading="isLoading">
					<el-table-column prop="measuringTime" label="测量时间" show-overflow-tooltip min-width="120"></el-table-column>
					<el-table-column label="收缩压(mmHg)" min-width="120">
						<template slot-scope="scope"><span class="lv" :class="['lv'+ scope.row.sbpLevel]">{{ scope.row.sbp ? scope.row.sbp : '未测量'}}</span>{{scope.row.sbpReferRange ? '('+scope.row.sbpReferRange+')' : ''}}</template>
					</el-table-column>
					<el-table-column label="舒张压(mmHg)" min-width="120">
						<template slot-scope="scope"><span class="lv" :class="['lv'+scope.row.dbpLevel]">{{ scope.row.dbp ? scope.row.dbp : '未测量'}}</span>{{scope.row.dbpReferRange ? '('+scope.row.dbpReferRange+')' : ''}}</template>
					</el-table-column>
					<!-- <el-table-column label="心率（次/分钟）" min-width="120">
						<template slot-scope="scope"><span class="lv" :class="['lv'+scope.row.hdlLevel]">{{ scope.row.hdl ? scope.row.hdl : '未测量'}}</span>{{scope.row.hdlReferRange ? '('+scope.row.hdlReferRange+')' : ''}}</template>
					</el-table-column> -->
					<el-table-column label="结果" min-width="120">
						<template slot-scope="scope"><span class="lv" :class="['lv'+scope.row.resultLevel]">{{ scope.row.result ? scope.row.result : '未测量'}}</span></template>
					</el-table-column>
					<el-table-column prop="dataType" label="数据源" width="100"></el-table-column>
					<el-table-column fixed="right" label="操作" width="100" >
						<template slot-scope="scope">
							<div class="tab-action" v-if="scope.row.dataType=='后台录入'">
								<el-tooltip content="修改" slot="reference" placement="top" :enterable="false">
										<i @click="onShowForm(scope.row)" class="el-icon-edit" />
								</el-tooltip>
								<el-popconfirm confirmButtonText='删除' title="确定删除吗？"  @confirm="delItem(scope.row)">
									<el-tooltip content="删除" slot="reference" placement="top" :enterable="false">
											<i class="el-icon-delete"></i>
									</el-tooltip>
								</el-popconfirm>
							</div>
						</template>
					</el-table-column>
				</el-table>
				<div class="pagination">
					<el-row>
						<el-col :span="12">
							<div class="record">当前是第<span v-text="(filter.pageNumber-1)*filter.pageSize+1"></span>条至第<span v-text="Math.min(list.total, (filter.pageNumber - 1) * filter.pageSize + filter.pageSize)"></span>数据</div>
							<div class="record">总计<span v-text="list.total"></span>条记录</div>
						</el-col>
						<el-col :span="12" style="text-align: right;">
							<el-pagination :disabled="isLoading" layout="sizes, prev, pager, next" :page-sizes="[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]"  prev-text="上一页" next-text="下一页" :current-page="list.current" :page-size="filter.pageSize" :total="list.total" @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
						</el-col>
					</el-row>
				</div>				
			</div>
			<div class="pane-mode chart" :class="{active: viewMode == 2}">
				<chart :options="chartOpts"></chart>
			</div>
		</div>


		<el-dialog :title.sync="dialogTit" width="550px" center :visible.sync="isFormActive">
			<el-form ref="form" label-width="120px" :rules="rules" :model="form">
				<el-form-item label="测量时间：" prop="measuringTime">
					<el-date-picker v-model="form.measuringTime" value-format="yyyy-MM-dd HH:mm:ss" :clearable="false" type="datetime"></el-date-picker>					
				</el-form-item>
				<el-form-item label="收缩压：" prop="sbp">
					<el-input clearable v-model.trim="form.sbp" ></el-input> mmHg
				</el-form-item>
				<el-form-item label="舒张压：" prop="dbp">
					<el-input clearable v-model.trim="form.dbp" ></el-input> mmHg
				</el-form-item>
				<!-- <el-form-item label="心率：" prop="hr">
					<el-input clearable v-model.trim="form.hr" ></el-input> 次/分钟
				</el-form-item> -->
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button type="primary" :loading="isLoading" @click="onSave">保 存</el-button>
			</div>
		</el-dialog>	


	</div>	
</template>

<script>
import mixin from '@/views/mixin';
import {Chart} from 'highcharts-vue';
import api from '@/service/api.js';
import dayjs from 'dayjs';
import { throttle } from "throttle-debounce";

export default {
	components: {Chart},
  mixins: [mixin],
	props: {
		patientId: { required: true }
	},
	data(){
		let checkResult = (rule, value, callback) => {
			if (!Number(value)) return callback(new Error('请输入数字值'))
			let reg = /^[0-9]*[1-9][0-9]*$/;
			if (!reg.test(value)) return callback(new Error('请输入正确数值'));
			callback();
		}
		return {
			noSidebar: true,
			sourceList:[],
			dialogTit:'',
			filter:{
				patientId: 0,
				dataType: '',
				type:'',
				measuringTimeStart: '',
				measuringTimeEnd: '',
				date: [],
				pageNumber: 1,
				pageSize: 30
			},
			viewMode: 1,
			isFormActive: false,
			rules: {
				dbp: [{required: true, message: '请输入', trigger: 'blur'},
				{ validator: checkResult, trigger: 'blur' },
					],
				sbp: [{required: true, message: '请输入', trigger: 'blur'},
				{ validator: checkResult, trigger: 'blur' },
				],
				hr: [{required: true, message: '请输入', trigger: 'blur'},
				{ validator: checkResult, trigger: 'blur' },
				],
			},			
			form: {
				patientId: 0,
				measuringTime: undefined,
				dbp: undefined,
				sbp: undefined,
				hr: undefined,
				vitalSignsId: '人工录入',
				dataType: 3,
				dataId: 0,
				// id: 0,
			},
			list: {pageSize: 30, pageCount: 50, total: 300,data: []},
			chartOpts: {
				title: {
					style: {color: '#2f4b6a'},
					// text: '最近1468天趋势图',
					text: null,
				},
				subtitle: {
					useHTML: true,
					style: {color: '#55759b'},
					text: undefined,
				},
				legend: {
					x: -50,
					borderWidth: 1,
					borderRadius: 5,
					layout: 'vertical',
					align: 'right',
					verticalAlign: 'top',
					floating: true
				},		
				tooltip: {valueSuffix: 'mmHg'},
				credits: {enabled: false},
				yAxis: {
					title: {style: {color: '#55759b'},text: '(mmHg)'},
					plotLines: [
						{label: {text: '舒张压目标:85mmHg', align: 'right', y: -10, style: {color: 'rgba(150,150,150,1)'}},color: 'red',width: 2,value: 85,dashStyle: 'longdashdot'},
						{label: {text: '收缩压目标:130mmHg', align: 'right', y: -10, style: {color: 'rgba(150,150,150,1)'}},color: 'blue',width: 2,value: 130,dashStyle: 'longdashdot'},
					],
					plotBands: [{
							from: 60,
							to: 85,
							color: 'rgba(241,241,128, .7)',
							label: {text: '舒张压正常区域', style: {color: 'rgba(150,150,150,.8)'}}
						}, {
							from: 90,
							to: 130,
							color: 'rgba(166,223,137, .7)',
							label: {text: '收缩压正常区域', style: {color: 'rgba(150,150,150,.8)'}}
						}
					]
				},
				xAxis: {
					// title: {text: 'Time'},
					// categories: ['09-30 20:55', '11-17 21:31', '11-23 10:10','09-30 20:55', '11-17 21:31', '11-23 10:10']
					categories: undefined
				},
				plotOptions: {
					line: {
						dataLabels: { enabled: true },
						enableMouseTracking: true
					}
				},					
				series: undefined
				// series: [{
				// 	name: '收缩压',
				// 	color: 'blue',
				// 	data: [125,98,130,110,75,122]
				// },{
				// 	name: '舒张压',
				// 	color: 'red',
				// 	data: [80,70,77,79,85,55],
				// 	allowPointSelect: false,
				// 	showInLegend: false
				// }]
			}		
		}
	},
	created() {
		// let query = this.$route.query;
		this.filter.patientId = this.patientId;
		this.loadList();
		
		// 获取 来源下拉
		api.getPatientBioSourceType({}).then((res)=>{
			if (res.code == 1000 && res.data) {
				this.sourceList = res.data;
			}
		});
	},
	methods: {
		async loadList(){
			// 获取 血压数据
			const filter = JSON.parse(JSON.stringify(this.filter));
			filter.date = undefined;
			let res = await api.getPatientBloodPressure(filter);
			if (res.code == 1000 && res.data) {
				if (res.data) {
					res.data.forEach((item)=>{
						item.sbpLevel = this.getLevel(1,item.sbpExceptionTip);
						item.dbpLevel = this.getLevel(1,item.dbpExceptionTip);
						item.resultLevel = this.getResultLevel(1,item.result);
					})
					this.list.total = +res.total;
					this.list.current = this.filter.pageNumber;
					this.list.pageSize = Math.ceil(this.list.total / this.filter.pageSize);					
					this.list.data = res.data;

					let labels = [];
					let sbps = [];
					let dbps = [];
					res.data?.forEach(item => {
						labels.push(item.measuringTime);
						sbps.push(+item.sbp);
						dbps.push(+item.dbp);
					});
					// 图表数据
					this.chartOpts.xAxis.categories = labels.reverse();
					this.chartOpts.series = [
						{
							name: '收缩压',
							color: 'blue',
							data: sbps.reverse()
						},
						{
							name: '舒张压',
							color: 'red',
							data: dbps.reverse()
						}
					];
					if (labels.length > 0) {
						this.chartOpts.subtitle.text = `<div>收缩压(峰值:${Math.max(...sbps)}mmHg 谷值:${Math.min(...sbps)}mmHg 均值: ${this.MathAvg(sbps)}mmHg)</div><div>舒张压(峰值:${Math.max(...dbps)}mmHg 谷值:${Math.min(...dbps)}mmHg 均值:${this.MathAvg(dbps)}mmHg)</div>`;	
					} else {
						this.chartOpts.subtitle.text = undefined;
					}
					
				}
			}

		},
		// 求平均值
		MathAvg(arr) {
			return (arr.reduce((pre, cur) => pre + cur) / arr.length).toFixed(1);
		},
		handleMode(key) {
			this.viewMode = key;
		},
		handleFilter(key, val) {
			if(val == 1){
				// 时间筛选
				if (this.filter.date) {
					this.filter.measuringTimeStart = dayjs(this.filter.date[0]).format('YYYY-MM-DD 00:00:00');
					this.filter.measuringTimeEnd = dayjs(this.filter.date[1]).format('YYYY-MM-DD 23:59:59');
				} else {
					this.filter.measuringTimeStart = '';
					this.filter.measuringTimeEnd = '';						
				}
			}
			this.filter.pageNumber = 1;
			this.loadList();
		},
		getLevel(v,key){
			if(v != 0){
				switch(key){
					case '高': return 4;
					case '低': return 1;
					default : return 0;
				}
			}
		},
		getResultLevel(v,key){
			if(v != 0){
				switch(key){
					case '血压偏低': return 1;
					case '血压正常高值': return 2;
					case '1级高血压': return 3;
					case '2级高血压': return 4;
					default : return 0;
				}
			}
		},
		onShowForm(item) {
			this.isFormActive = true;
			if(item=='add'){
				this.$refs['form'].resetFields();
				this.dialogTit='添加血压'
				this.form.measuringTime = dayjs().format('YYYY-MM-DD HH:mm:ss');
				this.form.sbp=undefined;
				this.form.dbp=undefined;
			} else{
				this.dialogTit='修改血压'
				this.form.measuringTime=item.measuringTime;
				this.form.sbp=item.sbp;
				this.form.dbp=item.dbp;
				this.form.id=item.id;
			}
		},
		onSave:throttle(3000,true,function(){
			this.$refs['form'].validate(async (valid)=>{
				if (valid) {
					this.form.patientId = this.patientId;
					if(this.dialogTit=='添加血压'){
						let res = await api.addPatientBloodPressure(this.form);
						if (res.code != 1000) {
							this.$message.console.error(res.msg);
							return;
						}
						this.$message.success('添加成功');
					} else {
						let res = await api.updatePatientLabBloodPressure(this.form);
						if (res.code != 1000) {
							this.$message.console.error(res.msg);
							return;
						}
						this.$message.success('修改成功');
					}
					this.isFormActive = false;
					this.loadList();					
				}
			});
		}),
		// onSave() {
		// 	this.$refs['form'].validate(async (valid)=>{
		// 		if (valid) {
		// 			this.form.patientId = this.patientId;
		// 			if(this.dialogTit=='添加血压'){
		// 				let res = await api.addPatientBloodPressure(this.form);
		// 				if (res.code != 1000) {
		// 					this.$message.console.error(res.msg);
		// 					return;
		// 				}
		// 				this.$message.success('添加成功');
		// 			} else {
		// 				let res = await api.updatePatientLabBloodPressure(this.form);
		// 				if (res.code != 1000) {
		// 					this.$message.console.error(res.msg);
		// 					return;
		// 				}
		// 				this.$message.success('修改成功');
		// 			}
		// 			this.isFormActive = false;
		// 			this.loadList();					
		// 		}
		// 	});
		// },
		handleSizeChange(v) {
			this.filter.pageSize = v;
			this.filter.pageNumber = 1;
			this.loadList();
		},
		handleCurrentChange(v) {
			this.filter.pageNumber = v;
			this.loadList();
		},	
		async delItem(item){
			let res =await api.delPatientLabBloodPressure([String(item.id)]);
			if(res.code==1000){
				this.$message.success('删除成功');
				this.loadList();
			}
		}
	}
}	
</script>
<style lang="less" scoped>
.tab-action{
	display: flex;
	justify-content: center;
}
</style>
